import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-talk-to-data-table-view',
  templateUrl: './talk-to-data-table-view.component.html',
  styleUrls: ['./talk-to-data-table-view.component.scss'],
})
export class TalkToDataTableViewComponent implements OnInit {
  @Input() isDark: boolean = false;
  @Input() dataSource: any[] = [];
  @Input() displayedColumns: string[] = [];
  @Input() reportPeriods: any[] = [];
  @Input() selectedPeriod: string = 'Past 7 days';
  @Input() entityType: string[] = ['report'];
  @Input() userTags: any[] = [];
  @Input() unSelectAllTag: boolean = false;
  @Input() csvLoader: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() saveReportLoader: boolean = false;
  @Input() showNoDataMessage: boolean = true;
  @Input() conversationState: string = 'initial';
  @Input() actionControlsDisabled: boolean = false;
  @Input() isWorkflowPending: boolean = false;

  @Output() periodChange = new EventEmitter<string>();
  @Output() tagsSelected = new EventEmitter<any>();
  @Output() tagDropdownClosed = new EventEmitter<void>();
  @Output() downloadReport = new EventEmitter<void>();
  @Output() saveReport = new EventEmitter<void>();

  filterForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  get hasData(): boolean {
    return this.conversationState === 'report_generated';
  }

  initializeForm(): void {
    this.filterForm = this.fb.group({
      period: [this.selectedPeriod],
      tags: [[]],
    });
  }

  onPeriodChange(period: string): void {
    this.selectedPeriod = period;
    this.periodChange.emit(period);
  }

  onTagsSelected(tags: any): void {
    this.tagsSelected.emit(tags);
  }

  onTagDropdownClosed(): void {
    this.tagDropdownClosed.emit();
  }

  onDownloadReport(): void {
    this.downloadReport.emit();
  }

  onSaveReport(): void {
    this.saveReport.emit();
  }
}
